import { Box, Skeleton } from '@mui/material';
import { useMemo } from 'react';

interface Props {
  numOfSkeletons?: number;
  skeletonHeight?: string;
}

const LoadingSkeletonGeneric: React.FC<Props> = ({
  numOfSkeletons = 6,
  skeletonHeight = '8rem',
}) => {
  const skeletonList = useMemo(() => {
    const skeletonList: JSX.Element[] = [];
    for (let i = 0; i < numOfSkeletons; i++) {
      skeletonList.push(
        <Skeleton
          key={i}
          sx={{
            backgroundColor: (theme) => theme.colors.darkTheme.grey.medium,
            height: skeletonHeight,
            width: '100%',
            borderRadius: (theme) => theme.recentScansPage.card.borderRadius,
          }}
          animation='wave'
          variant='text'
        />
      );
    }

    return skeletonList;
  }, [numOfSkeletons, skeletonHeight]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
      }}
    >
      {skeletonList}
    </Box>
  );
};

export default LoadingSkeletonGeneric;
